// import emHome from "@/views/em/Home";

import mintalMesPrd from "@/router/mintalMes/prd/moduleIndex-router-mintalMes-prd"
import mintalMesMst from "@/router/mintalMes/mst/moduleIndex-router-mintalMes-mst"
import mintalMesQuality from "@/router/mintalMes/quality/moduleIndex-router-mintalMes-quality"
import mintalMesInventory from "@/router/mintalMes/inventory/moduleIndex-router-mintalMes-inventory"

export default [
    ...mintalMesPrd,
    ...mintalMesMst,
    ...mintalMesQuality,
    ...mintalMesInventory
]